import { render, staticRenderFns } from "./EquipmentsView.vue?vue&type=template&id=0d8fece4&scoped=true"
import script from "./EquipmentsView.vue?vue&type=script&lang=js"
export * from "./EquipmentsView.vue?vue&type=script&lang=js"
import style0 from "./EquipmentsView.vue?vue&type=style&index=0&id=0d8fece4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8fece4",
  null
  
)

export default component.exports